import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { shareReplay, takeUntil, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';

@Injectable()
export class CanvasService {

    private _summary$: Observable<any> = null;
    private _assignments$: Observable<any> = null;
    //private _assignmentsToday$: Observable<any> = null;
    private _reload$ = new Subject<void>();             // used to trigger resubscribe/reload

    constructor(
        private http: HttpClient,
        private logger: LoggerService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.Canvas, category);
    }

    public get summary$() {
        if (!this._summary$) {
            this._summary$ = this.http.get<any>(environment.apiUrl + '/canvas/summary').pipe(
                tap( (data) => this.log('summary$', 'Fetched canvas summary', LogCategory.SubscriptionData)),
                    takeUntil(this._reload$),
                    shareReplay(1)
                );
            }

        return this._summary$;
    }

    public get assignments$() {
        if (!this._assignments$) {
            this._assignments$ = this.http.get<any>(environment.apiUrl + '/canvas/assignments').pipe(
                tap((data) => this.log('assignments$', 'Fetched canvas assignments', LogCategory.SubscriptionData)),                
                takeUntil(this._reload$),
                shareReplay(1)
            );
        }

        return this._assignments$;
    }

    // adf211223: We don't appear to be using this 
    //public get assignmentsToday$() {
    //    if (!this._assignmentsToday$) {
    //        this._assignmentsToday$ = this.http.get<any>(environment.apiUrl + '/canvas/assignments/agenda').pipe(
    //            tap((data) => this.log('_assignmentsToday$', 'Fetched canvas assignmentsToday', LogCategory.SubscriptionData)),
    //            takeUntil(this._reload$),
    //            shareReplay(1)
    //        );
    //    }

    //    return this._assignmentsToday$;
    //}
}
